declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function trackEvent(eventName: string, eventParams: Record<string, unknown> = {}): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
}

// ─── Wizard Events ────────────────────────────────────────────────────────────

/** Fired when the user completes all wizard steps and a result is shown */
export function trackWizardCompleted(params: {
  occasion: string;
  budget: number;
  currency: string;
  gender: string;
}): void {
  trackEvent('wizard_completed', {
    occasion: params.occasion,
    budget_value: params.budget,
    currency: params.currency,
    gender: params.gender,
  });
}

/** Fired when the wizard fails (AI error) */
export function trackWizardError(params: { occasion?: string; budget?: number }): void {
  trackEvent('wizard_error', {
    occasion: params.occasion ?? 'unknown',
    budget_value: params.budget ?? 0,
  });
}

/** Fired when the user retries after an error */
export function trackWizardRetry(): void {
  trackEvent('wizard_retry');
}

/** Fired when the user resets the wizard to start over */
export function trackWizardReset(): void {
  trackEvent('wizard_reset');
}

// ─── Occasion / Budget Distribution Events ────────────────────────────────────

/** Fired when the user selects an occasion */
export function trackOccasionSelected(occasion: string): void {
  trackEvent('occasion_selected', { occasion });
}

/** Fired when the user confirms a budget */
export function trackBudgetSelected(budget: number, currency: string): void {
  trackEvent('budget_selected', {
    budget_value: budget,
    currency,
    budget_tier:
      budget < 100 ? 'under_100'
      : budget < 300 ? '100_299'
      : budget < 600 ? '300_599'
      : budget < 1000 ? '600_999' :'1000_plus',
  });
}

// ─── Share / Save Conversion Events ──────────────────────────────────────────

/** Fired when the user saves (bookmarks) an outfit */
export function trackOutfitSaved(params: {
  occasion: string;
  budget: number;
  currency: string;
  aesthetic?: string;
}): void {
  trackEvent('outfit_saved', {
    occasion: params.occasion,
    budget_value: params.budget,
    currency: params.currency,
    aesthetic: params.aesthetic ?? 'unknown',
  });
}

/** Fired when the user removes a saved outfit */
export function trackOutfitUnsaved(params: { occasion: string }): void {
  trackEvent('outfit_unsaved', { occasion: params.occasion });
}

/** Fired when the user creates a share link */
export function trackOutfitShared(params: {
  method: 'link' | 'pinterest' | 'instagram' | 'text';
  occasion: string;
  aesthetic?: string;
}): void {
  trackEvent('outfit_shared', {
    share_method: params.method,
    occasion: params.occasion,
    aesthetic: params.aesthetic ?? 'unknown',
  });
}
